import {
  ManageSharingSection,
  DetailSection,
  ViewLayout,
  AdvanceStack,
  OtherLayout,
} from '../components';
import { RibbonBar, RibbonDivider } from 'common/components';

import { EditPreviewBtn } from './components';

const FormExcel = () => {
  return (
    <RibbonBar>
      <ManageSharingSection />
      <DetailSection />
      <ViewLayout disabled />
      <AdvanceStack isDisabled />
      <RibbonDivider />
      <EditPreviewBtn />
      <RibbonDivider />
      <OtherLayout ribbonSide='right' isHaveAddOpenItem={false} />
    </RibbonBar>
  );
};

export default FormExcel;
